import Gumshoe from 'gumshoejs'
import axios from 'axios'
import swal from 'sweetalert'
import Swiper from 'swiper'
import AOS from 'aos'
import Pikaday from 'pikaday'

const headerDom = document.querySelector('header')
const footerDom = document.querySelector('footer')
const contentDom = document.querySelector('.main')
const hamburgerMenuClick = document.querySelector('.mobile-hamburger')
const headerMenu = document.querySelector('.main-menu')
const headerMenuList = document.querySelectorAll('.main-menu li')
const formDom = document.querySelectorAll('.app-form')
const htmlDom = document.querySelector('html')
const outerPage = document.querySelector('.outer-page')
const modelsPopupClose = document.querySelector('.models-popup-close')
const formPopupClose = document.querySelector('.form-popup-close')
const formPopupCloseDownload = document.querySelector('.form-popup-close-download')
const modelsTrArrow = document.querySelector('.models-1-tr-arrow')
const checkboxDummy = document.querySelectorAll('.checkbox-dummy')
const formPopupText = document.getElementById('formPopupText')
const outerPageForm = document.querySelector('.outer-page-form')
const outerPageFormDownload = document.querySelector('.outer-page-form-download')
const formPopupField = document.getElementById('formPopupField')
const choose = document.getElementById('choose')
const formMeetSchedule = document.getElementById('formMeetSchedule')
const formDemoSchedule = document.getElementById('formDemoSchedule')
const formN2lSchedule = document.getElementById('formN2lSchedule')
const formTema = document.getElementById('formTema')
const banner = document.querySelector('.banner')
const formBusinessDom = document.querySelectorAll('.app-form-business')

const downloadNetAppCheck = document.getElementById('downloadNetApp')
const downloadCaseStudyCheck = document.getElementById('downloadCaseStudy')

const findTheRightDataCheck = document.getElementById('findTheRightData')
const triggerBtnPopup = document.querySelectorAll('.trigger-btn-popup')

let shouldPopupShow = true
let formPopupType = ''
let downloadTypeName = ''

hamburgerMenuClick.addEventListener('click', () => {
  headerMenu.classList.add('header-menu--show')
  htmlDom.classList.add('no-scroll')
})

headerMenuList.forEach((list) => {
  list.addEventListener('click', () => {
    headerMenu.classList.remove('header-menu--show')
    htmlDom.classList.remove('no-scroll')
  })
})

function isInViewport (elem) {
  const bounding = elem.getBoundingClientRect()
  return parseInt(bounding.bottom, 10) < (window.innerHeight || document.documentElement.clientHeight)
}

function download(url, name) {
  const shadowLinkTag = document.createElement('a');
  shadowLinkTag.href = url;
  shadowLinkTag.download = name;
  shadowLinkTag.click();
}

function goToUrl(url) {
  const shadowLinkTag = document.createElement('a');
  shadowLinkTag.href = url;
  shadowLinkTag.click();
}

function headerScroll() {
  const wScroll = window.scrollY
  const models1TrGray = document.querySelector('.models-1-tr-gray')

  if (wScroll > 40) {
    headerDom.classList.add('header--scroll')
  } else {
    shouldPopupShow = !shouldPopupShow
    headerDom.classList.remove('header--scroll')
  }

  if (models1TrGray) {
    if (isInViewport(models1TrGray) && shouldPopupShow) {
      setTimeout(() => {
        outerPage.classList.add('outer-page--show')
      }, 500)
      htmlDom.classList.add('no-scroll')
      shouldPopupShow = false
    }
  }
}

modelsPopupClose.addEventListener('click', () => {
  outerPage.classList.remove('outer-page--show')
  htmlDom.classList.remove('no-scroll')
})

formPopupClose.addEventListener('click', () => {
  const formPopupField = document.getElementById('formPopupField')
  const theFields = formPopupField.querySelectorAll('.form__input')

  let idCheck = null

  theFields.forEach((field) => {
    idCheck = field.dataset.chk
  })
  
  const checkBoxId = document.getElementById(idCheck)
  checkBoxId.checked = false

  outerPageForm.classList.remove('outer-page-form--show')
  htmlDom.classList.remove('no-scroll')
}) 

headerScroll()

window.addEventListener('scroll', headerScroll)

AOS.init({
  duration: 400,
  easing: 'ease',
  startEvent: 'DOMContentLoaded',
  once: true
})

window.onload = () => {
  contentDom.style.marginTop = `${headerDom.offsetHeight}px`
  contentDom.style.marginBottom = `${footerDom.offsetHeight}px`

  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    initialSlide: 0,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      960: {
        autoHeight: false
      },
      768: {
        autoHeight: false,
        autoplay: false
      },
      540: {
        autoHeight: true,
        autoplay: false
      },
      320: {
        autoHeight: true,
        autoplay: false
      }
    }
  })

  setTimeout(() => {
    if (banner) {
      banner.classList.add('banner--show')
      htmlDom.classList.add('no-scroll')
    }
  }, 3000)
}

const spy = new Gumshoe('#mainNav a', {
  reflow: true,
  offset() {
    return headerDom.getBoundingClientRect().height
  }
})

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    })
  })
})



const serialize = (formEl) => {
  const formData = [];
  for (let i = 0; i < formEl.elements.length; i++) {
    const field = formEl.elements[i];
    if (field.name && !field.disabled && field.type !== 'button' && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit') {
      if (field.type === 'checkbox' && !field.checked) {
        continue
      }
      formData[formData.length] = `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`;
    }
  }
  return formData.join('&').replace(/%20/g, '+');
};

formBusinessDom.forEach((form) => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const data = serialize(this);
    const btnSubmit = this.querySelector('[type="submit"]');
    const btnText = btnSubmit.textContent;
    btnSubmit.setAttribute('disabled', 'true');
    btnSubmit.textContent = 'Submitting...';
    axios.post('https://predictable-hci.com/form-business.php', data)
      .then((res) => {
        if (res.data.success) {
          const isFindCheck = findTheRightDataCheck.checked

          if (downloadTypeName === 'whitepaper') {
            swal('Terima kasih', 'Mengunduh... Whitepaper NetApp', 'success')
            setTimeout(() => {
              download('https://predictable-hci.com/assets/2-NetApp-VDI.pdf', '2-NetApp-VDI.pdf')
            }, 3000)
          } else if (downloadTypeName === 'datasheet1') {
            swal('Terima kasih', 'Mengunduh... Datasheet NetApp', 'success')
            setTimeout(() => {
              download('https://predictable-hci.com/assets/3-ActiveIQ.pdf', '3-ActiveIQ.pdf')
            }, 3000)
          } else if (downloadTypeName === 'datasheet2') {
            swal('Terima kasih', 'Mengunduh... Datasheet NetApp', 'success')
            setTimeout(() => {
              download('https://predictable-hci.com/assets/4-Cloud-Insight.pdf', '4-Cloud-Insight.pdf')
            }, 3000)
          } else if (isFindCheck) {
            swal('Terima kasih', 'Data sukses terkirim', 'success')
              .then((value) => {
                goToUrl('https://explore.netapp.com/us/netappsmi?&cid=3769')
              })
          } else {
            swal('Terima kasih', 'Data sukses terkirim', 'success');
          }
    
        } else {
          swal('Opps', res.data.message, 'error');
        }
      })
      .catch((err) => {
        swal('Opps', 'We are under maintenance', 'error');
        console.log(err);
      })
      .finally(() => {
        this.reset();
        grecaptcha.reset();
        btnSubmit.removeAttribute('disabled');
        btnSubmit.textContent = btnText;
        formMeetSchedule.value = ''
        formDemoSchedule.value = ''
        downloadTypeName = ''
      });
  })
})

/*  eslint func-names: ["off"] */
/*  eslint prefer-arrow-callback: ["off"] */
formDom.forEach((form) => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const data = serialize(this);
    const btnSubmit = this.querySelector('[type="submit"]');
    const btnText = btnSubmit.textContent;
    btnSubmit.setAttribute('disabled', 'true');
    btnSubmit.textContent = 'Submitting...';
    axios.post('https://predictable-hci.com/form.php', data)
      .then((res) => {
        if (res.data.success) {
          swal('Terima kasih', 'Data sukses terkirim', 'success');
        } else {
          swal('Opps', res.data.message, 'error');
        }
      })
      .catch((err) => {
        swal('Opps', 'We are under maintenance', 'error');
        console.log(err);
      })
      .finally(() => {
        this.reset();
        grecaptcha.reset();
        btnSubmit.removeAttribute('disabled');
        btnSubmit.textContent = btnText;
        formMeetSchedule.value = ''
        formDemoSchedule.value = ''
        formN2lSchedule.value = ''
        formTema.value = ''
      });
  })
})

function setInputFilter(textbox, inputFilter) {
  ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      /*  eslint no-prototype-builtins: ["off"] */
      } else if (this.hasOwnProperty('oldValue')) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  });
}

document.querySelectorAll('.input__number-only').forEach((input) => {
  setInputFilter(input, function (value) {
    return /^\d*\.?\d*$/.test(value);
  });
});

if (modelsTrArrow) {
  modelsTrArrow.addEventListener('click', function() {
    outerPage.classList.add('outer-page--show')
    htmlDom.classList.add('no-scroll')
  })
}

checkboxDummy.forEach((check) => {
  check.addEventListener('click', function() {
    let name = this.getAttribute('name')
    if (
      name === 'downloadCaseStudy' || name === 'downloadNetApp' || name === 'downloadNetAppBusinessContinuity' || name === 'downloadWhitepaperNetApp' || name === 'downloadDatasheetNetApp' || name === 'downloadDatasheetNetAppCloud' || name === 'findTheRightData') {
      return
    }
    formPopupType = name
    if (this.checked) {
      if (name === 'meeting') {
        formPopupText.textContent = 'Jangan sampai ketinggalan manfaat jajaran produk NetApp untuk perusahaan Anda. Temui expertise kami sekarang!'
        formPopupField.innerHTML = `
          <div class="form__group">
            <label for="schedule">Preferred Schedule<sup>*</sup>:</label>
            <div class="inline-field">
              <span><i class="fas fa-calendar-alt"></i></span>
              <input type="text" name="schedule" class="form__input datepicker" required placeholder="Silahkan Pilih Hari" autocomplete="off" id="dt1" data-chk="meeting">
            </div>
          </div>
        `
        const picker = new Pikaday({
          field: document.getElementById('dt1'),
          format: 'DD/MM/YYYY',
          minDate: new Date(),
          firstDay: 1
        })
      } else if (name === 'demo') {
        formPopupText.textContent = 'Buktikan ketangguhan NetApp membantu memodernisasi infrastruktur IT dan bisnis Anda. Jadwalkan demo sekarang?'
        formPopupField.innerHTML = `
          <div class="form__group">
            <label for="schedule">Preferred Schedule<sup>*</sup>:</label>
            <div class="inline-field">
              <span><i class="fas fa-calendar-alt"></i></span>
              <input type="text" name="schedule" class="form__input datepicker" required placeholder="Silahkan Pilih Hari" autocomplete="off" id="dt2" data-chk="demo">
            </div>
          </div>
        `
        const picker = new Pikaday({
          field: document.getElementById('dt2'),
          format: 'DD/MM/YYYY',
          minDate: new Date(),
          firstDay: 1
        })
      } else {
        formPopupText.innerHTML = '<p>Sebagai partner teknologi Anda, kami dengan senang hati mengundang Anda untuk peer to peer sharing tentang teknologi terbaru, mulai dari Hybrid Cloud Infrastructure hingga Artificial Intelligence. Anda bisa tentukan topik dan jadwal sesuai pilihan Anda.</p><p>Kami peduli dengan kesehatan dan keselamatan Anda. Selama situasi corona, program N2L akan diubah menjadi sesi virtual.</p>'
        formPopupField.innerHTML = `
          <div class="form__group">
            <label for="tema">Tema Diskusi<sup>*</sup>:</label>
            <select name="tema" id="tema" class="form__input" data-chk="join">
              <option value="null" selected="selected" disabled="disabled">Pilih Tema Diskusi</option>
              <option value="Hybrid Cloud">Hybrid Cloud</option>
              <option value="Infrastructure">Infrastructure</option>
              <option value="Artificial Intelligence">Artificial Intelligence</option>
              <option value="Enterprise Apps">Enterprise Apps</option>
              <option value="DevOps">DevOps</option>
              <option value="VDI">VDI</option>
              <option value="Others">Others</option>
            </select>
          </div>
          <div class="form__group">
            <label for="schedule">Preferred Schedule<sup>*</sup>:</label>
            <div class="inline-field">
              <span><i class="fas fa-calendar-alt"></i></span>
              <input type="text" name="schedule" class="form__input datepicker" required placeholder="Silahkan Pilih Hari" autocomplete="off" id="dt3" data-chk="join">
            </div>
          </div>
        `
        const picker = new Pikaday({
          field: document.getElementById('dt3'),
          format: 'DD/MM/YYYY',
          minDate: new Date(),
          firstDay: 1
        })

        const select = document.querySelectorAll('select')
        select.forEach((s) => {
          s.addEventListener('click', function () {
            this.classList.add('clicked')
          })
        })
      }
      outerPageForm.classList.add('outer-page-form--show')
      htmlDom.classList.add('no-scroll')
    } else {
      if (name === 'meeting') {
        formMeetSchedule.value = ''
      } else if (name === 'demo') {
        formDemoSchedule.value = ''
      } else {
        formN2lSchedule.value = ''
        formTema.value = ''
      }
    }
  })
})

choose.addEventListener('click', () => {
  const input = outerPageForm.querySelector('input')
  if (formPopupType === 'meeting') {
    if (input.value) {
      formMeetSchedule.value = input.value
      outerPageForm.classList.remove('outer-page-form--show')
      htmlDom.classList.remove('no-scroll')
    }
  } else if (formPopupType === 'demo') {
    if (input.value) {
      formDemoSchedule.value = input.value
      outerPageForm.classList.remove('outer-page-form--show')
      htmlDom.classList.remove('no-scroll')
    }
  } else {
    const select = outerPageForm.querySelector('select')
    if (input.value && select.value) {
      formN2lSchedule.value = input.value
      formTema.value = select.value
      outerPageForm.classList.remove('outer-page-form--show')
      htmlDom.classList.remove('no-scroll')
    }
  }
})

if (banner) {
  banner.addEventListener('click', (e) => {
    if (e.target.classList.contains('banner-content')) {
      banner.classList.remove('banner--show')
      htmlDom.classList.remove('no-scroll')
    }
  })
}

const heroScrollDown = document.querySelector('.hero-scroll-down')

if (heroScrollDown) {
  heroScrollDown.addEventListener('click', () => {
    document.querySelector('.overview-one').scrollIntoView({ 
      behavior: 'smooth' 
    });
  })
}

triggerBtnPopup.forEach((popup) => {
  popup.addEventListener('click', function() {
    const downloadType = this.dataset.download
    downloadTypeName = downloadType
    outerPageFormDownload.classList.add('outer-page-form-download--show')
    const inputHiddenDownload = outerPageFormDownload.querySelector('#downloadInputHidden')
    
    if (downloadType === 'whitepaper') {
      inputHiddenDownload.name = 'downloadWhitepaperNetApp'
      inputHiddenDownload.value = 'Download Whitepaper NetApp VDI'
    } else if (downloadType === 'datasheet1') {
      inputHiddenDownload.name = 'downloadDatasheetNetApp'
      inputHiddenDownload.value = 'Download Datasheet NetApp Active IQ'
    } else if (downloadType === 'datasheet2') {
      inputHiddenDownload.name = 'downloadDatasheetNetAppCloud'
      inputHiddenDownload.value = 'Download Datasheet NetApp Cloud Insight'
    }
  })
})

if (formPopupCloseDownload) {
  formPopupCloseDownload.addEventListener('click', () => {
    outerPageFormDownload.classList.remove('outer-page-form-download--show')
  })
}